export default "__VITE_ASSET__e72397e4__"